import {
	ADMINLOYALTYPOINTOPERATION_SUCCESS,
	ADMINLOYALTYPOINTOPERATION_FAILED,
	RESET_ADMINLOYALTYPOINTOPERATION,
	LOADING_ADMINLOYALTYPOINTOPERATION,
	NETWORK_ERROR_ADMINLOYALTYPOINTOPERATION
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINLOYALTYPOINTOPERATION:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINLOYALTYPOINTOPERATION_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINLOYALTYPOINTOPERATION_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINLOYALTYPOINTOPERATION:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINLOYALTYPOINTOPERATION:
			return (state = initialState);
		default:
			return state;
	}
};
